// src/pages/CrowdfundingDashboard.jsx
import React, { useState } from 'react';

// Sub-components for different Project Stages
const IdeaGenerator = () => (
  <div className="p-6 bg-white rounded shadow">
    <h3 className="text-xl font-bold mb-4">💡 Idea Generator & AI Polish</h3>
    <div className="space-y-4">
      <input type="text" placeholder="Problem you want to solve..." className="w-full border p-2 rounded" />
      <input type="text" placeholder="Target Audience..." className="w-full border p-2 rounded" />
      <button className="bg-purple-600 text-white px-4 py-2 rounded">
        ✨ Ask AI to Polish UVP
      </button>
    </div>
  </div>
);

const InvestmentFund = () => (
  <div className="p-6 bg-white rounded shadow border-l-4 border-green-500">
    <h3 className="text-xl font-bold mb-4">💰 Aulice Investment Fund</h3>
    <div className="grid md:grid-cols-2 gap-6">
      <div className="bg-gray-50 p-4 rounded">
        <h4 className="font-semibold">Crowdfunding Marketplace</h4>
        <p className="text-sm text-gray-600 mb-2">Browse alumni projects and invest "Aulice Credits".</p>
        <button className="text-blue-600 underline text-sm">View Top Rated Projects</button>
      </div>
      <div className="bg-gray-50 p-4 rounded">
        <h4 className="font-semibold">Request Funding</h4>
        <p className="text-sm text-gray-600 mb-2">Submit your "Project Blueprint" for seed funding.</p>
        <button className="bg-green-600 text-white px-4 py-1 rounded text-sm w-full">
          Start Application
        </button>
      </div>
    </div>
  </div>
);

const LobbyingCenter = () => (
  <div className="p-6 bg-white rounded shadow border-l-4 border-red-500">
    <h3 className="text-xl font-bold mb-4">🏛️ Aulice Lobbyist & Reinforcements</h3>
    <p className="text-sm text-gray-600 mb-4">Need help with government institutions or legal issues?</p>
    <div className="space-y-3">
      <select className="w-full border p-2 rounded">
        <option>Select Reinforcement Type...</option>
        <option>Tax Consultant</option>
        <option>Corporate Lawyer</option>
      </select>
      <textarea placeholder="Describe your specific question..." className="w-full border p-2 rounded h-24"></textarea>
      <button className="bg-red-600 text-white px-6 py-2 rounded w-full">
        Submit Task to Lobbyist
      </button>
    </div>
  </div>
);

const CrowdfundingDashboard = () => {
  const [activeTab, setActiveTab] = useState('My Projects');

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <h1 className="text-4xl font-extrabold text-gray-800 mb-2">Aulice Community Investment</h1>
      <p className="text-gray-600 mb-8">Incubate, Finance, and Scale Alumni Projects.</p>

      {/* Tabs */}
      <div className="flex space-x-4 border-b mb-6">
        {['My Projects', 'Investment Fund', 'Lobbying & Support'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 px-4 ${activeTab === tab ? 'border-b-2 border-indigo-600 text-indigo-600 font-bold' : 'text-gray-500'}`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="grid gap-6">
        {activeTab === 'My Projects' && <IdeaGenerator />}
        {activeTab === 'Investment Fund' && <InvestmentFund />}
        {activeTab === 'Lobbying & Support' && <LobbyingCenter />}
      </div>
    </div>
  );
};

export default CrowdfundingDashboard;